export const knownRouteParameters = [
    'organizationId',
    'centerId',
    'folderId',
    'voucherId',
    'serviceId',
    'id',
    'insuranceAbbr',
    'invoiceId',
    'billingBatchId',
    'billingDocumentId',
    'billingId',
    'workplaceId',
    'code',
    'paymentId',
    'serviceMedicalProcedureId',
    'patternId',
    'operationalReportId',
    'nursingDiagnosisId',
    'workId',
    'sickNoteId',
    'serviceTypeId',
    'offerId',
    'contractId',
    'warehouseMaterialId',
    'projectId',
    'year',
    'month',
    'clientId',
    'reportType',
] as const;

export type knownRouteParametersKey = typeof knownRouteParameters[number];
